import React from 'react';
import Toaster from './TrackerToaster';

class ActivityTracker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeForAlert: false,
        };
        this.onLogout = props.onLogout;
        // events to listen to
        this.events = [
            'load','click', 'scroll', 
            'keypress', 'touch', 'submit'
        ];
    }

    componentDidMount() {
        // loop for each keyboard and mouse events
        this.events.forEach((event) => {
            window.addEventListener(event, this._resetTimeout);
        });
    }

    componentDidUpdate(){
        this.events.forEach((event) => {
            window.addEventListener(event, this._resetTimeout);
        });
    }

    _clearTimeout = () => {
        // when lib is made, we can do many warn times
        if(this.warnTimeout)
            clearTimeout(this.warnTimeout);
  
        if(this.logoutTimeout)
            clearTimeout(this.logoutTimeout);
    }
  
    _setTimeout = () => {
        // warn time is 15 minutes and logout time is 30 minutes
        this.warnTimeout = setTimeout(this._warn, 15 * 60 * 1000);
        this.logoutTimeout = setTimeout(this._logout, 30 * 60 * 1000);
    }
  
    _resetTimeout = () => {
        this._clearTimeout();
        this._setTimeout();

        this.setState({
            timeForAlert: false
        });
    }
  
    _warn = () => {
        this.setState({
            timeForAlert: true
        });
    }
  
    _logout = () => {
        this._clearTimeout();
        // set state to initial state
        this.setState({
            timeForAlert: false
        });
        // remove all event listeners before logging out
        this.events.forEach((event) => {
            window.removeEventListener(event, this._resetTimeout);
        });
        if (this.onLogout)   
            this.onLogout();
    }

    render() {
        const { timeForAlert } = this.state;

        return (
            <div>
                {
                    timeForAlert 
                        ?
                        <Toaster 
                            props={{
                                header: '15 Min to Log Out',
                                body: 'You will be logged out after 15 minutes'
                            }}
                        />
                        :
                        this.props.children
                }
            </div>
        );
    }
}

export default ActivityTracker;
